<template>
  <section class="container">
    <div :class="{ '-mt-24': !isIE }">
      <img src="~/assets/img/currency_icon.png" class="inline" />
      <h1
        v-if="!isIE"
        class="text-4xl font-bold text-theme-secondary font-theme-title"
      >
        Einen Moment bitte...
      </h1>
      <h1
        v-else
        class="text-4xl font-bold text-theme-secondary font-theme-title"
      >
        Oh nein!
      </h1>
      <p v-if="!isIE" class="text-white">
        Sollten Sie nicht weitergeleitet werden, klicken Sie bitte
        <a
          href="#"
          class="text-white uppercase"
          @click="redirect()"
        > Hier </a>
      </p>
      <p v-else class="text-white">
        Dieser Browser wird nicht unterstützt!<br />Laden Sie sich einen
        gängigen Browser herunter um die Ländlepunkte zu benutzen.<br /><br />
        <a href="https://www.vol.at" class="text-white"> Zurück zu VOL.AT </a>&nbsp;|&nbsp;
        <a href="https://bestvpn.org/outdatedbrowser/de.html" class="text-white">
          Browser entdecken
        </a>
      </p>
      <br />
      <div class="links">
        <img src="~/assets/img/logo-vol.svg" class="inline w-16" />
      </div>
    </div>
  </section>
</template>

<script>
import { mapStores } from 'pinia'
import { useMainStore } from '~/store/main'

export default {
  components: {},
  layout: 'static',
  data() {
    return {
      entry: '',
      hidden: null,
      visibilityChange: null,
      isIE: false,
      OSs: {
        // Sometimes, Windows Phone contains Android in it’s UA
        // To prevent it from overlapping with Android, try Windows first
        windows: {
          store_prefix: 'zune:navigate?appid=',
          test: /Windows\s+Phone|IEMobile/i,
        },

        android: {
          store_prefix: 'https://play.google.com/store/apps/details?id=',
          test: /Android/i,
        },

        iOS: {
          store_prefix: 'https://itunes.apple.com/en/app/id',
          test: /iPhone|iPad|iPod/i,
        },
      },
    }
  },
  computed: {
    ...mapStores(useMainStore),
    weblink() {
      const url = new URL(this.mainStore.frontend_url)
      url.searchParams.set('tee', this.entry)

      const oldUrl = new URL(window.location)

      oldUrl.searchParams.forEach((value, key) => {
        if (key !== 'entry') {
          url.searchParams.set(key, value)
        }
      })

      return url
    },
    applink() {
      return `volat://tee/webview?entry=${this.entry}`
    },
    iOS() {
      return (
        !!navigator.userAgent.match(/iPad/i)
        || !!navigator.userAgent.match(/iPhone/i)
      )
    },
    webkit() {
      return !!navigator.userAgent.match(/WebKit/i)
    },
    iOSSafari() {
      return this.iOS && this.webkit && !navigator.userAgent.match(/CriOS/i)
    },
  },
  mounted() {
    this.entry = new URL(window.location.href).searchParams.get('entry')
    if (typeof document.hidden !== 'undefined') {
      // Opera 12.10 and Firefox 18 and later support
      this.hidden = 'hidden'
      this.visibilityChange = 'visibilitychange'
    }
    else if (typeof document.msHidden !== 'undefined') {
      this.hidden = 'msHidden'
      this.visibilityChange = 'msvisibilitychange'
    }
    else if (typeof document.webkitHidden !== 'undefined') {
      this.hidden = 'webkitHidden'
      this.visibilityChange = 'webkitvisibilitychange'
    }

    this.isIE = this.detectIE()
    if (!this.isIE) {
      this.redirect()
    }
  },
  methods: {
    userAgent() {
      for (const k in this.OSs) {
        if (navigator.userAgent.match(this.OSs[k].test)) { return k }
      }
      return ''
    },
    redirect() {
      if (this.userAgent()) {
        this.mobileHandler()
      }
      else {
        this.webHandler()
      }
    },
    mobileHandler() {
      const delay = 2000

      // Store start time
      const start = Date.now()
      let clicked = true

      // Timeout to detect if the link worked
      let timeout = setTimeout(() => {
        // Check if any of the values are unset
        if (!clicked || !timeout) { return }

        // Get current time
        const now = Date.now()

        // Reset things
        clicked = false
        timeout = null

        // Has the user left the screen? ABORT!
        if (now - start >= delay * 2) { return }

        // Open original link
        this.webHandler()
      }, delay)

      if (!this.iOSSafari) {
        // Go to app
        window.location.href = this.applink
      }

      document.addEventListener(
        this.visibilityChange,
        () => {
          if (document[this.hidden]) {
            if (!clicked || !timeout) { return }

            // Reset everything
            timeout = clearInterval(timeout)
            clicked = false
          }
        },
        false,
      )
    },
    webHandler() {
      window.location.href = this.weblink
    },
    detectIE() {
      const sAgent = window.navigator.userAgent
      const Idx = sAgent.indexOf('MSIE')

      // If IE, return version number.
      if (Idx > 0) {
        return true
      }

      // If IE 11 then look for Updated user agent string.
      if (/Trident\/7\./.test(navigator.userAgent)) {
        return true
      }

      return false // It is not IE
    },
  },
}
</script>

<style>
.container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-left: 10px;
  padding-right: 10px;
}

.title {
  font-family: 'Quicksand', 'Source Sans Pro', -apple-system, BlinkMacSystemFont,
    'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; /* 1 */
  display: block;
  font-weight: 300;
  font-size: 100px;
  color: #35495e;
  letter-spacing: 1px;
}

.subtitle {
  font-weight: 300;
  font-size: 42px;
  color: #526488;
  word-spacing: 5px;
  padding-bottom: 15px;
}

.links {
  padding-top: 15px;
}
</style>
